<template>
    <div class="flex border-t border-l border-r border-gray-200 bg-white">
        <estimate-cost-list-update-fixed-cost-dropdown #default="{ open:openConfirm, close:close }"
                                                       class="flex-1"
                                                       :item="fixedCost"
                                                       :original="item"
                                                       :type="type"
                                                       :align-right="true"
                                                       @updated="update"
                                                       @closed="closedUpdate"
                                                       menu-class="w-96"
                                                       trigger-class="flex w-full">
            <div class="flex-1 flex">
                <estimate-task-item-fixed-cost-search
                    class="flex w-full my-0"
                    menu-class="w-[34em]"
                    #default="{ open, query, setQuery }"
                    :store="store"
                    :estimate="estimate"
                    @selected:fixedCost="(e) => fixedCostSelected(e,openConfirm)"
                    @change="openConfirm()"
                    :top="true"
                >
                    <!-- Name. -->
                    <autoresizable-textarea :height="el => (el.scrollHeight + 2) + 'px'"
                                            ref="autoresizable-textarea" v-if="!estimate.readonly">
                <textarea
                    placeholder="Name..."
                    class="text-sm -ml-px mr-px -my-px px-2 py-1.5 border border-gray-200 shadow-none relative hover:z-10 focus:z-20 resize-none bg-white"
                    type="text"
                    ref="name"
                    v-model="fixedCost.description"
                    rows="1"
                    @focus="setQuery($event.target.value);open()"
                    @input="setQuery($event.target.value);openConfirm()"
                ></textarea>
                    </autoresizable-textarea>
                    <div v-else
                         class="text-sm -ml-px mr-px -my-px px-2 py-1.5 whitespace-pre-wrap border border-gray-200 shadow-none relative hover:z-10 focus:z-20 resize-none bg-white"
                         v-text="fixedCost.description"
                    ></div>
                </estimate-task-item-fixed-cost-search>
            </div>
            <div class="w-20 m-0 -mx-px flex">
                <page-cell
                    class="text-sm -ml-px -my-px px-2 py-1.5 border-gray-200"
                    placeholder="Uom..."
                    @input="openConfirm()"
                    :read-only="estimate.readonly"
                    v-model="fixedCost.unit"
                    ref="cost"
                ></page-cell>
            </div>
            <div class="w-28 w- m-0 -mx-px flex">
                <page-cell
                    currency
                    class="text-sm -ml-px -my-px px-2 py-1.5 border-gray-200"
                    placeholder="Rate..."
                    @input="openConfirm()"
                    :read-only="estimate.readonly"
                    v-model="fixedCost.rate"
                    ref="cost"
                ></page-cell>
            </div>
            <div class="w-20 m-0 -mx-px flex">
                <div class="w-full bg-gray-50 -my-px -ml-px border px-2 py-1.5 text-sm text-right">
                    {{ item.quantity | rounded }}
                </div>
            </div>
            <div class="w-28 m-0 -mx-px flex">
                <div class="w-full bg-gray-50 -my-px mr-0 border px-2 py-1.5 text-sm text-right">
                    {{ item.rate * item.quantity | toCurrency }}
                </div>
            </div>
        </estimate-cost-list-update-fixed-cost-dropdown>
    </div>
</template>

<script>

import AutoresizableTextarea from "../../../ui/AutoresizableTextarea";
import EstimateTaskItemMaterialSearch from "../build/EstimateTaskItemMaterialSearch.vue";
import EstimateCostListCostUpdateMaterialDropdown from "./EstimateCostListUpdateMaterialDropdown.vue";
import {resolveNumericText} from "../../../../utils";
import EstimateCostListUpdateFixedCostDropdown from "./EstimateCostListUpdateFixedCostDropdown.vue";

export default {
    components: {
        EstimateCostListUpdateFixedCostDropdown,
        EstimateCostListCostUpdateMaterialDropdown, EstimateTaskItemMaterialSearch, AutoresizableTextarea
    },
    props: {
        estimate: Object,
        target: Object,
        item: Object,
        store: Object,
        type: String,
    },
    data() {
        return {
            fixedCost: {description: this.item.description, unit: this.item.unit, rate: this.item.rate},
            resolveNumericText,
        }
    },
    computed: {},
    methods: {
        fixedCostSelected({fixedCostDescription, fixedCostUnit, fixedCostRate}, openConfirm) {
            this.fixedCost.description = fixedCostDescription
            this.fixedCost.unit = fixedCostUnit
            this.fixedCost.rate = this.resolveNumericText(fixedCostRate)
            openConfirm()
        },
        update(e) {
            this.fixedCost.rate = this.resolveNumericText(this.fixedCost.rate)
            this.$emit('updateFixedCost', {from: this.item, to: this.fixedCost})
        },
        closedUpdate(e) {
            this.$nextTick(() => {
                this.fixedCost = {description: this.item.description, unit: this.item.unit, rate: this.item.rate}
            })
        }
    },
}
</script>
